<template>
  <v-app-bar class="navigation_menu_bar ma-0" :scroll-behavior="scrollBehavior" scroll-threshold="300" :elevation="0">
    <template v-slot:append>
      <VRow class="navigation_menu_row">
        <a href="/"><img :src="getResourceUrl(`/cdn/${sportTitle}/site/logo-combi.svg`)" class="tech_hero_icon" :alt="`${sportTitle}Levels`" /></a>
        
        <!-- Only render SearchWidget if hideSearchWidget is not true -->
        <SearchWidget :disable-teleport="false" v-if="!route.meta.hideSearchWidget" class="navigation_menu_div navigation_hide_mobile" />
        
        <!-- Include the Communities Widget component, hide on Logged Out and on route pages -->
        <span class="navigation_communities_span" style="width: 100%">
          <template v-if="!route.meta.hideCommunitiesWidget">
            <CommunitiesWidget v-if="$attrs.isLoggedIn" class="navigation_menu_div navigation_hide_mobile" :siteMap="siteMap" />
          </template>
        </span>

        <!-- Include the User Tech Bar component (Logged In Only) -->
        <UserTechBar v-if="$attrs.isLoggedIn" class="navigation_menu_div" />
        
        <!-- Include the User Registration Bar component (Logged Out Only) -->
        <UserRegistrationBar v-if="$attrs.isLoggedOut" id="user_registration_bar" class="navigation_menu_div" />
        
      </VRow>
    </template>
  </v-app-bar>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { ref, onMounted, computed } from 'vue';
import { useUserDataStore } from '@/store/userDataStore';
import { getResourceUrl, sportTitle } from '@/services/admin_actions/apiUtils';

import UserTechBar from '@/components/SingleElements/UserTechBar.vue';
import SearchWidget from '@/components/GlobalComponents/SearchWidget.vue';
import CommunitiesWidget from '@/components/SingleElements/CommunitiesWidget.vue';
import UserRegistrationBar from '@/components/SingleElements/UserRegistrationBar.vue';

// Initialize the Pinia store for accessing user data
const userDataStore = useUserDataStore();
const route = useRoute(); // Accessing the current route

// Computed properties to get the required items from the Pinia store's state
const siteMap = computed(() => userDataStore.menuData.site_map);

// Get the window width
const width = ref(window.innerWidth);

// Detect device type based on width and set scroll behavior
const scrollBehavior = computed(() => {
  if (width.value >= 1024) {
    return 'hide';
  } else {
    return 'inverted';
  }
});

onMounted(() => {
  // Update width on window resize
  window.addEventListener('resize', () => {
    width.value = window.innerWidth;
  });
});
</script>

<style lang="scss">
:root {
  --safe-area-inset-top-ios: env(safe-area-inset-top, 0px);
  --safe-area-inset-bottom-ios: env(safe-area-inset-bottom, 0px);
}

// Control global navigation padding and gaps
header .v-toolbar__append {
  margin-inline-start: 10px;
  margin-inline-end: 20px;
  width: 100%;
  margin-top: calc(var(--safe-area-inset-top-ios, 0px)) !important;
}

// Unique color for the mobile menu bar
.navigation_menu_bar .v-toolbar__content {
  background-color: $darker-grey;
  padding: 0px;
}

// Style the navigation menu row to be flex and have a gap between the items
.navigation_menu_row {
  gap: 20px;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}

// Style the navigation menu divs to have a max width
.navigation_menu_div {
  max-width: 500px;
}

// Ensure the logo is always 26px high
.tech_hero_icon {
  display: none;
  height: 28px;
}

// Media Queries for Navigation Component on Tablet Screens
@media only screen and (max-width: $tablet-screen) {
  // Hide the Tech Hero Icon on Tablet screens
  .tech_hero_icon {
    display: none;
  }
  
  // Hide the Communities Widget on Tablet screens
  .navigation_hide_mobile {
    display: none;
  }
}

// Media Queries for Navigation Component on Mobile Screens
@media only screen and (max-width: $mobile-screen) {
  header .v-toolbar__append {
    margin-inline-start: 20px;
    margin-inline-end: 15px;
    width: 100%;
  }
  
  .navigation_menu_row {
    gap: 20px;
    // Hide Search Widget on mobile screens
    .search_widget_container {
      display: none;
    }
    .tech_user_bar {
      height: 50px;
    }
  }
  
  // Unique mobile color for the mobile menu bar
  .navigation_menu_bar .v-toolbar__content {
    background-color: rgba(var(--v-theme-primary));
    height: calc(50px + var(--safe-area-inset-top-ios, 0px)) !important;
  }
  
  // Ensure the logo is displayed on mobile screens
  .tech_hero_icon {
    display: flex;
  }
  
  // Hide the Communities Widget on mobile screens
  .navigation_hide_mobile {
    display: none;
  }
  
  // Hide empty space for Communities Widget on mobile screens
  .navigation_communities_span {
    display: none;
  }
}
</style>
